import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { DecimalPipe } from '@angular/common';
import { salesMasterHoldDetails } from './salesmasterholddetails';

export interface SalesMasterHoldParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface SalesMasterHold { 

    phBillId?: any;
    indentId:number;
    phBillNo:any;
    phdoctorid:string;
    phBillDate:any;
    phBillTotal:number;
    phGSTTotal:number;
    phDiscounttype:string;
    phRoundofftpe:string;
    phDiscountpercentage:number;
    phDiscountamount:number;
    phRoundoff:number;
    phNettotal:number;
    phAmountReceived:number;
    phAmountReturned:number;
    phReceiptmode:string;
    phSaleType:string;
    phBillTowhom:string;
    phBillCustomerId:number;
    phBillRegId:string;
    phBillAdmId:number;
    createdBy:any;
    createdDate:any;
    branchId: string;
    tenantId: string;  
        
    //New Column
      
    updatedBy: any; 
    updatedDate: Date;
    updatedIP: string;  
    createdIP: string;
   
    salesMasterHoldDetDto: salesMasterHoldDetails[];
    
    parameters?: SalesMasterHoldParameter[];
    links?: any;
}


export abstract class salesMasterHoldData {
    abstract getall(url: string): Observable<SalesMasterHold[]>;
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: SalesMasterHold): Observable<SalesMasterHold[]>;
    abstract update(url: string, data: SalesMasterHold): Observable<SalesMasterHold>;
    abstract list(url: string): Observable<any>; 
}
